<script>
  export let idUnico = 'flipcard';
  export let hasLegenda = false;
  export let content;

  import conteudo from '../../conteudo';
  import { location } from 'svelte-spa-router';
  import { onMount } from 'svelte';

  let legenda = [];
  let tagBegin;
  let tagEnd;

  let aspectBegin;
  let aspectEnd;
  let aspect_ratio;

  aspectBegin = content.indexOf('{{');
  if (aspectBegin != -1) {
    aspectEnd = content.indexOf('}}');
    if (aspectEnd != -1) {
      aspect_ratio = content.substring(aspectBegin + '{{'.length, aspectEnd);
      content = content.substring(aspectEnd + '}}'.length, content.length);
    }
  }

  let root;

  tagBegin = content.indexOf('<legenda>');
  if (tagBegin != -1) {
    tagEnd = content.indexOf('</legenda>');
    if (tagEnd != -1) {
      legenda = content.substring(tagBegin + '<legenda>'.length, tagEnd);
      if (content.substring(tagBegin + '<legenda>'.length, tagEnd).trim() != '') {
        legenda = content.substring(tagBegin + '<legenda>'.length, tagEnd).split(';;');
        hasLegenda = true;
        content = content.substring(0, tagBegin);
      }
    }
  }

  let grupos = [];
  grupos = content.split(';;');
  console.log(grupos);

  let grupo = [];
  let images = [];
  grupos.forEach((element, index) => {
    if (element.trim() != '') {
      if (element.includes('::')) {
        grupo[index] = element.split('::');
      }
    }
    images[index] =
      conteudo.imagePath +
      'flipcard_m' +
      conteudo.modulo +
      '_u' +
      idUnico.split('-')[1] +
      '_' +
      (index + 1) +
      '.png';
  });

  onMount(() => {
    j$.each(j$(`#${idUnico} .flip-container > div`), (index, element) => {
      j$(element).click(() => {
        j$(element).toggleClass('rotate');
      });
    });

    root.style.setProperty('--aspect_ratio', aspect_ratio);
    if (aspect_ratio == '1/1') {
      root.style.setProperty('--grid_template_desk', '1fr 1fr 1fr');
      root.style.setProperty('--grid_template_mob', 'calc(70% - 30px)');
      root.style.setProperty('--card_width', '100%');
      root.style.setProperty('--card_height', 'unset');
    } else {
      root.style.setProperty('--grid_template_desk', '1fr');
      root.style.setProperty('--grid_template_mob', '1fr');
      root.style.setProperty('--card_width', 'unset');
      root.style.setProperty('--card_height', '260px');
    }
  });
</script>

<div class="container" id={idUnico} bind:this={root}>
  <div class="flip-container">
    {#each grupo as g, index}
      <div>
        <div class="front">
          <img src={images[index]} alt="" />
        </div>
        <div class="back">
          <h3>{@html g[0]}</h3>
          <p>{@html g[1]}</p>
        </div>
      </div>
    {/each}
  </div>
  <div class="wrapper-margin justify-content-center">
    {#if hasLegenda}
      <div class="legenda-wrapper">
        {@html legenda[0] ? legenda[0] : ''}
        {@html legenda[1] ? legenda[1] : ''}
        {@html legenda[2] ? legenda[2] : ''}
        {@html legenda[3] ? legenda[3] : ''}
        {@html legenda[4] ? legenda[4] : ''}
        {@html legenda[5] ? legenda[5] : ''}
        {@html legenda[6] ? legenda[6] : ''}
      </div>
    {/if}
  </div>
</div>

<style>
  .flip-container {
    display: grid;
    grid-template-columns: var(--grid_template_desk);
    column-gap: 10px;
    row-gap: 20px;
    /* margin: 0 20%; */
    justify-items: center;
  }
  .flip-container > :global(div.rotate) {
    transform: rotateY(180deg);
    /* box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2); */
  }

  .flip-container > :global(div:hover) {
    /* box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3); */
  }
  .flip-container > :global(div) {
    position: relative;
    display: flex;
    transition: all 350ms ease;
    transform-style: preserve-3d;
    transform: rotateY(0deg);
    border-radius: 15px;
    /* box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1); */
    cursor: pointer;
    aspect-ratio: var(--aspect_ratio);
    height: var(--card_height);
    width: var(--card_width);
  }

  .flip-container > :global(div:last-child) {
    /* margin: 0 15px 0 15px; */
  }

  .flip-container > :global(div .back),
  .flip-container > :global(div .front) {
    height: 100%;
    width: 100%;
    transform-style: preserve-3d;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 15px;
    border: 4px solid #b6d7d5;
    border: 4px solid var(--VERDE_CLARO_60);
  }

  .flip-container > :global(div .front img:hover) {
    /* transform: scale(1.05); */
    /* transition: 500ms all ease; */
  }
  .flip-container > :global(div .front) {
    /* transform: translateZ(0.1px) scale(1); */
    background: var(--VERDE_CLARO_20);
    background: #add7d3;
    /* background: white; */
    display: flex;
    justify-content: center;
  }
  .flip-container > :global(div.rotate .front) {
    /* transform: translateZ(0.1px) scale(0.995); */
  }

  .flip-container > :global(div .back) {
    transform: translateZ(-0.1px) rotateY(180deg);
    border-radius: 15px;
    display: flex;
    align-items: center;
    /* justify-content: center; */
    flex-direction: column;
    background: white;
    background: var(--CINZA);
    /* background: var(--VERDE); */
    padding: 10px 15px;
    border: 4px solid var(--VERDE_CLARO);
  }

  .flip-container > :global(div .back span) {
    color: var(--MARROM);
    font-weight: 700;
  }

  .flip-container :global(p) {
    margin: 0;
    padding: 0;
    line-height: 1.3;
    font-size: 17px;
    color: var(--PRETO);
    font-weight: 400;
  }
  .flip-container :global(h3) {
    margin: 5px 0 10px 0;
    padding: 0;
    color: var(--MARROM);
    font-family: var(--FONT_INTER);
    font-size: 17px;
    text-align: center;
    display: block;
    font-weight: 700;
  }

  .flip-container :global(img) {
    width: 100%;
    border-radius: 11px;
    filter: drop-shadow(0 5px 5px #00000055);
    transition: 300ms all ease;
  }

  .legenda-wrapper :global(span) {
    font-style: normal;
    font-size: 11px;
    color: white;
    background: var(--MARROM);
    padding: 0 5px;
    border-radius: 3px;
    /* font-size-adjust: 0.5; */
    /* line-height: 1; */
    transform: translateY(-1px);
    display: inline-block;
  }

  .wrapper-margin {
    margin: 0 15%;
  }
  .legenda-wrapper {
    width: 100%;
    --Gradientes-Degrad-principal: linear-gradient(to right, #33cfb9, #b62ca2);
    --Gradientes-Degrad-principal-inv: linear-gradient(
      to left,
      var(--VERDE_CLARO),
      var(--VERDE_LEGENDA)
    );
    --Principais-Texto: #000000;
    --cor-primaria: #b62ca2;
    --cor-secundaria: #33cfb9;
    --Infogrficos-Cinza: #e1e4e5;
    --Infogrficos-Cinza: #fff;
    color: var(--Principais-Verde-mdio, #559c92);
    color: var(--MARROM);
    text-align: right;
    font-family: var(--FONT_LORA);
    font-size: 14px;
    font-style: italic;
    font-weight: 500;
    border-radius: 0 0 30px 0px;
    padding: 15px 20px 15px 10px;
    border-right: 2px solid transparent;
    border-bottom: 2px solid transparent;
    background-image: linear-gradient(var(--Infogrficos-Cinza), var(--Infogrficos-Cinza)),
      var(--Gradientes-Degrad-principal-inv);
    background-origin: border-box;
    background-clip: padding-box, border-box;
    line-height: normal;
    text-wrap-style: pretty;
    position: relative;
    z-index: 2;
  }
  .legenda-wrapper:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to right, white, #f2f2f2, white),
      linear-gradient(to bottom, #f2f2f2, white);
    /* background: white; */
    z-index: -1;
    border-radius: 0 0 32px 0;
  }

  .legenda-wrapper :global(div:nth-child(1)) {
    font-size: 16px;
    color: var(--VERDE_LEGENDA);
  }

  @media (max-width: 767px) {
    .flip-container {
      grid-template-columns: var(--grid_template_mob);
      row-gap: 10px;
      column-gap: 0;
      /* margin-left: calc(17.5vw - 7.5px); */
      justify-content: center;
      margin: 0;
    }
    .flip-container > :global(div .back),
    .flip-container > :global(div .front) {
      width: 100%;
      height: 100%;
    }
    .flip-container > :global(div) {
      width: 100%;
      height: unset;
      aspect-ratio: 1;
    }
    .flip-container :global(img) {
      object-fit: cover;
    }
    .wrapper-margin {
      margin: 0;
    }
  }
</style>
